'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatLngFromAddress = exports.getAddressFromPostalCode = undefined;

/**
 * 郵便番号から住所をGoogleのAPIを利用して取得します。
 * このメソッド内ではtry-catchしていないため、呼び出し側で行ってください。
 *
 * @export
 * @param {?string} [apiKey] GoogleのAPIキー
 * @param {?string} [postalCode] 郵便番号文字列
 * @returns fetchのレスポンスオブジェクト
 */
var getAddressFromPostalCode = exports.getAddressFromPostalCode = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiKey, postalCode) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch('https://maps.googleapis.com/maps/api/geocode/json?new_forward_geocoder=true&components=country:JP%7Cpostal_code:' + (postalCode || '') + '&key=' + (apiKey || ''), {
              method: 'GET'
            }).then(function (response) {
              return (0, _handleErrors.handleFetchResponse)(response);
            });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getAddressFromPostalCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getLatLngFromAddress = exports.getLatLngFromAddress = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apiKey, address) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + (address || '') + '&key=' + (apiKey || ''), {
              method: 'GET'
            }).then(function (response) {
              return (0, _handleErrors.handleFetchResponse)(response);
            });

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getLatLngFromAddress(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.loadGoogleMapsApi = loadGoogleMapsApi;
exports.getPlacePredictions = getPlacePredictions;
exports.getPlaceDetail = getPlaceDetail;

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _map = require('../constants/map');

var _map2 = _interopRequireDefault(_map);

var _handleErrors = require('../rest/handle-errors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function loadGoogleMapsApi(apiKey, libraries) {
  if (!window.google || window.google && !window.google.maps) {
    // GoogleMapAPIのライブラリを読み込み
    var googleMapLoader = _googleMapReact2.default.googleMapLoader;

    var bootstrapURLKeys = {};
    bootstrapURLKeys.key = apiKey || '';
    if (libraries) {
      bootstrapURLKeys.libraries = libraries;
    }
    googleMapLoader(bootstrapURLKeys).then(function (maps) {
      window.google = {
        maps: maps
      };
    });
  }
}

function getPlacePredictions(autocompleteService, input) {
  return new Promise(function (resolve, reject) {
    if (!input) {
      reject();
      return;
    }
    var params = {
      input: input,
      location: new google.maps.LatLng(_map2.default.defaultLatitude, _map2.default.defaultLongitude),
      radius: 500000,
      types: ['geocode']
    };
    autocompleteService.getPlacePredictions(params, function (predictions, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        var places = [];
        var others = [];
        predictions.forEach(function (prediction) {
          if (!(prediction.types.length > 0 && prediction.types[0] === 'establishment')) {
            places.push(prediction);
          } else {
            others.push(prediction);
          }
        });
        resolve(places.concat(others));
      } else {
        reject(status);
      }
    });
  });
}

var getRadiusByViewport = function getRadiusByViewport(viewport) {
  var radius = 2.0;
  if (viewport) {
    var distance = parseFloat(google.maps.geometry.spherical.computeDistanceBetween(viewport.getNorthEast(), viewport.getSouthWest()));
    if (distance < 2000.0) distance = 2000.0;
    // radius = distance / 1000.0 / 2.0;
    // 本来は2で割るのが正解だが、スペース少ないので対象範囲を広めにしている
    radius = distance / 1000.0 / 1.5;
  }
  return radius;
};

var getGeocode = function getGeocode(lat, lng, radius) {
  if (lat && lng) {
    return lat + ',' + lng + ',' + (radius || 2) + 'km';
  }
  return '';
};

function getPlaceDetail(placeId, htmlElement) {
  return new Promise(function (resolve, reject) {
    var googlePlacesService = new google.maps.places.PlacesService(htmlElement);
    googlePlacesService.getDetails({ placeId: placeId }, function (details, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK && details) {
        var location = details.geometry.location;
        var viewport = details.geometry.viewport;
        var radius = getRadiusByViewport(viewport);
        resolve(getGeocode(location.lat(), location.lng(), radius));
      } else {
        reject(status);
      }
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/places.js
// module id = 523
// module chunks = 0